// ============================================================
//  SU01-Adressfelder (Funktion, Abteilung) sind Kontoattribute je System — gepflegt oder nicht,
//  manchmal veraltet. Für eine Person zeigen wir den häufigsten gepflegten Wert und kennzeichnen,
//  wenn ihre Konten sich widersprechen. Nichts wird mit dem Personalstamm überschrieben.
// ============================================================
import type { Account, Person } from "./types";

export interface Su01View {
  funktion?: string;
  abteilung?: string;
  /** Konten dieser Person nennen unterschiedliche Funktionen bzw. Abteilungen. */
  widerspruch: boolean;
  /** Konten mit mindestens einem gepflegten SU01-Feld. */
  gepflegt: number;
}

function haeufigster(values: string[]): { wert?: string; verschieden: number } {
  const m = new Map<string, number>();
  for (const v of values) if (v) m.set(v, (m.get(v) ?? 0) + 1);
  let best: string | undefined, n = 0;
  for (const [v, c] of m) if (c > n) { best = v; n = c; }
  return { wert: best, verschieden: m.size };
}

export function su01Of(p: Person, accById: Map<string, Account>): Su01View {
  const accs = p.accountIds.map((id) => accById.get(id)).filter((a): a is Account => !!a);
  const f = haeufigster(accs.map((a) => a.su01Function ?? ""));
  const d = haeufigster(accs.map((a) => a.su01Department ?? ""));
  return {
    funktion: f.wert, abteilung: d.wert,
    widerspruch: f.verschieden > 1 || d.verschieden > 1,
    gepflegt: accs.filter((a) => a.su01Function || a.su01Department).length,
  };
}
